import { LinearGradient } from 'expo-linear-gradient'
import React, { useEffect, memo } from 'react'
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import theme from '../../../../theme'
import styles from '../../stores/StoreDetailStyles'
import { StoreKPIIndicatorTheme } from '../../../../themeConstants'
import { AnimatedCircularProgress } from 'react-native-circular-progress'
import Constants from 'expo-constants'

export const StoreKPIIndicators = React.memo(({ item, index }: any) => {
    const expoConfig = Constants.expoConfig || { slug: '' }
    const getGradientColors = (index) => {
        const gradientIndex = index % 5
        const isInverted = Math.floor(index / 5) % 2 === 1
        const gradientStartKey = `linearGradientStart0${gradientIndex}`
        const gradientEndKey = `linearGradientEnd0${gradientIndex}`

        // console.log(`Index: ${index}, Gradient Index: ${gradientIndex}, Is Inverted: ${isInverted}`)
        // console.log(`Start Color Key: ${gradientStartKey}, End Color Key: ${gradientEndKey}`)
        // console.log(`Start Color: ${theme.colors[gradientStartKey]}, End Color: ${theme.colors[gradientEndKey]}`)

        if (isInverted) {
            return [theme.colors[gradientEndKey], theme.colors[gradientStartKey]]
        } else {
            return [theme.colors[gradientStartKey], theme.colors[gradientEndKey]]
        }
    }
    //console.log('ITEM KPI ==>', item)
    const gradientColors = getGradientColors(index) as unknown as readonly [
        string,
        string,
    ]

    const renderItem = (type: string, value: number = 0) => {
        switch (type) {
            case 'percentage':
                const fix = 0 // value === 100 ? 0 : 1
                const progressText = value === -1 ? '-' : `${value.toFixed(fix)}%`

                return (
                    <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                        {/* <Progress.Circle
                            size={70}
                            progress={value / 100}
                            showsText={false}
                            thickness={8}
                            color={StoreKPIIndicatorTheme.progressFilledColor}
                            unfilledColor={
                                StoreKPIIndicatorTheme.progressUnfilledCollor
                            }
                            borderWidth={0}
                            strokeCap='round'
                        /> */}
                        <AnimatedCircularProgress
                            size={70}
                            style={{ height: 50 }}
                            width={7}
                            fill={value}
                            tintColor={StoreKPIIndicatorTheme.progressFilledColor}
                            backgroundColor={
                                StoreKPIIndicatorTheme.progressUnfilledCollor
                            }
                            padding={0}
                            rotation={-90}
                            arcSweepAngle={180}
                            lineCap='round'
                        >
                            {() => (
                                <Text
                                    style={{
                                        maxWidth: 70,
                                        fontSize: 13,
                                        fontWeight: 'bold',
                                        color: 'white',
                                        marginTop: 0,
                                    }}
                                    numberOfLines={1}
                                    adjustsFontSizeToFit
                                    minimumFontScale={0.5}
                                >
                                    {progressText}
                                </Text>
                            )}
                        </AnimatedCircularProgress>
                    </View>
                )
            default: //"number"
                return (
                    <View
                        style={{
                            width: 75,
                            height: 50,
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Text
                            style={{
                                fontSize: 50,
                                color: 'white',
                                fontWeight: '700',
                                textAlign: 'center',
                            }}
                            numberOfLines={1}
                            adjustsFontSizeToFit
                            minimumFontScale={0.7}
                        >
                            {value}
                        </Text>
                    </View>
                )
        }
    }

    const setChangeColor = (value) => {
        if (
            !value ||
            value === '0' ||
            value === '0%' ||
            value === '' ||
            value === '-'
        ) {
            return 'white'
        }
        if (typeof value === 'string') {
            if (value.trim().startsWith('+')) {
                return '#8fe98f'
            }
            if (value.trim().startsWith('-')) {
                return '#e00000'
            }
        }
        return 'green'
    }

    const showLR =
        (item.monthOverMonthPercentChange &&
            item.monthOverMonthPercentChange != '') ||
        expoConfig.slug === 'savencia-one'
    // console.log('ITEM ==>', item)
    return (
        <View style={[styles.containerItemsIndicators]}>
            <TouchableOpacity activeOpacity={1}>
                <LinearGradient
                    style={[
                        {
                            width: 120,
                            borderRadius: 20,
                            padding: 12,
                            marginLeft: 8,
                            height: 135,
                        },
                    ]}
                    colors={gradientColors}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0.5 }}
                >
                    <Text
                        style={[
                            {
                                fontSize: 11,
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                color: 'white',
                                marginTop: 5,
                            },
                        ]}
                        numberOfLines={1}
                    >
                        {item.kpi}
                    </Text>
                    <View
                        style={[
                            styles.containerProgress,
                            { height: undefined, marginTop: 10 },
                        ]}
                    >
                        {renderItem(item.type, item.value)}
                    </View>
                    {item?.criticalMomentCode && (
                        <Text
                            style={[
                                {
                                    fontSize: 11,
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    textAlign: 'center',
                                    color: 'white',
                                    marginTop: 5,
                                },
                            ]}
                            numberOfLines={1}
                        >
                            {item.criticalMomentCode}
                        </Text>
                    )}
                    {showLR && (
                        <Text
                            style={{
                                fontSize: 11,
                                color: 'white',
                                marginBottom: 0,
                                marginTop: 2,
                                textAlign: 'center',
                            }}
                        >
                            {'Variación LR'}
                            {'\n'}
                            <Text
                                style={{
                                    color: setChangeColor(
                                        item?.monthOverMonthPercentChange,
                                    ),
                                    fontWeight: '700',
                                    fontSize: 13,
                                }}
                                numberOfLines={1}
                            >
                                {item?.monthOverMonthPercentChange || '-'}
                            </Text>
                        </Text>
                    )}
                </LinearGradient>
            </TouchableOpacity>
        </View>
    )
})
